module.exports = __webpack_public_path__ + "img/logo-rss.35700ced.svg";